import { useQuery } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';

const useGetTemplates = ({ open }) => {
  const {
    data = [],
    isFetching,
    isError,
  } = useQuery(
    ['diagnostic-templates'],
    async () => {
      const response = await instance.get(`/nexa/diagnostic-templates`);
      return response.data;
    },
    {
      enabled: open,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity, // Never consider data stale
      notifyOnChangeProps: ['isFetching', 'isError', 'data'],
    },
  );

  return { data, isFetching, isError };
};

export default useGetTemplates;
